import React from 'react';
import SpotCardGrid from './SpotCardGrid';
import {Heading, Box, useBreakpointValue, Loader} from '@spothero/ui';
import {PropTypes} from 'prop-types';
import {
    spotListStyleProps,
    spotListTitleStyleProps,
    spotListAreaStyleProps,
    pulseLoaderContainerStyleProps,
} from './SpotListStyleProps';
import {DEFAULT_DAYS} from '../../../common/constants';

function SpotList({
    isDesktop,
    trackingLink,
    destinationId,
    destinationName,
    availableSpots,
    loading,
    selectedStartDate,
    selectedStartTime,
    selectedEndDate,
    selectedEndTime,
}) {
    const numberOfSpots = useBreakpointValue({base: 2, tablet: 3});

    return (
        <Box {...spotListAreaStyleProps}>
            <Heading as="h4" {...spotListTitleStyleProps}>
                Recommended Spots
            </Heading>
            <Box {...spotListStyleProps}>
                {loading ? (
                    <Box
                        {...pulseLoaderContainerStyleProps}
                        data-testid="PulseLoaderContainer"
                    >
                        <Loader />
                    </Box>
                ) : (
                    availableSpots.slice(0, numberOfSpots).map((spot, i) => {
                        const spotId = spot?.facility?.common?.id;

                        return (
                            <SpotCardGrid
                                isDesktop={isDesktop}
                                key={spotId}
                                spot={spot}
                                trackingLink={trackingLink}
                                destinationName={destinationName}
                                destinationId={destinationId}
                                days={DEFAULT_DAYS}
                                selectedEndDate={selectedEndDate}
                                selectedEndTime={selectedEndTime}
                                selectedStartDate={selectedStartDate}
                                selectedStartTime={selectedStartTime}
                                data-testid="spotCard"
                            />
                        );
                    })
                )}
            </Box>
        </Box>
    );
}

SpotList.propTypes = {
    isDesktop: PropTypes.bool.isRequired,
    trackingLink: PropTypes.string.isRequired,
    destinationId: PropTypes.number.isRequired,
    availableSpots: PropTypes.array.isRequired,
    destinationName: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    selectedStartDate: PropTypes.object.isRequired,
    selectedStartTime: PropTypes.string.isRequired,
    selectedEndDate: PropTypes.object.isRequired,
    selectedEndTime: PropTypes.string.isRequired,
};

export default SpotList;
